import loadScript from '@/utils/load-script';
import '../../../public/libs/layer/3.1.1/theme/default/layer.css';
import './myLayer.scss';

export default async function() {
    if (!window.jQuery) await loadScript('/libs/jquery/2.2.2/jquery.min.js')
    if (!window.layer) await loadScript('/libs/layer/3.1.1/layer.js')



    window.layer.config({
        maxmin: false,
        move: false,
        area: ['893px', '600px'],
    })

    const resize = () => {
        console.log('resize');
        $('.layui-sub-page').width(document.body.clientWidth - 200);
        $('.layui-sub-page,.layui-sub-page iframe').height(document.body.clientHeight - 60);
    }

    window.layer.openSubpage = function(url, options) {
        window.layer.open({
            skin: 'layui-sub-page',
            content: url,
            type: 2,
            title: false,
            closeBtn: 0,
            shade: 0,
            shadeClose: false,
            area: [document.body.clientWidth - 200 + 'px', document.body.clientHeight - 60 + 'px'],
            offset: ['60px', '200px'],
            ...options,
            success() {
                window.addEventListener('resize', resize, false);
            },
            end() {
                console.log('销毁');
                window.removeEventListener('resize',resize);
            }
        });
    }

    window.myLayer = window.layer;
}
